import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import {
	fetchDepotHeadersFail,
	fetchDepotHeadersSuccess,
	fetchDepotListFail,
	fetchDepotListSuccess,
	initAvailableDepotHeadersForEntityCreation,
	initDepotList,
	refreshDepotList,
	updateIncludePublic,
	fetchDepotSchemaMappingSuccess,
	openDepotHeaderFieldsSelection,
	reconstructDepotSchemaMappingSuccess,
	replaceCurrentLabelWith,
	triggerDetectAvailableHeaders,
	resetAvailableHeaders,
	updateEntitiesCountForDepotSuccess,
	deleteDepot,
	bulkDeleteDepots,
	deleteDepotFail,
	getDepotHeaderSettingSuccess,
	createEntityFromDepot,
	createEntityFromDepotSuccess,
	createEntityFromDepotFail,
} from './depot.actions';
import { DepotOriginalSliceState } from './depot.state';

export const depotOriginalReducer = createReducer<DepotOriginalSliceState>(
	new DepotOriginalSliceState(),
	on(goToProjects, setProject, (state) => state.clear()),
	on(initDepotList, refreshDepotList, createEntityFromDepot, (state) =>
		state.setLoading(true)
	),
	on(
		fetchDepotListFail,
		createEntityFromDepotSuccess,
		createEntityFromDepotFail,
		(state) => state.setLoading(false)
	),
	on(fetchDepotListSuccess, (state, action) =>
		state.setLoading(false).setDepotList(action.depotList)
	),
	on(updateIncludePublic, (state, action) =>
		state.setLoading(true).toggleIncludePublicProjects(action.includePublic)
	),
	on(initAvailableDepotHeadersForEntityCreation, (state) =>
		state.setLoading(true)
	),
	on(resetAvailableHeaders, (state) => state.deleteHeadersForState()),
	on(fetchDepotHeadersSuccess, (state, action) =>
		state
			.setLoading(false)
			.setAvailableCharacteristicTypes(action.availableCharacteristicTypes)
			.setAvailableDateFormats(action.availableDateFormats)
			.setAvailableTimezones(action.availableTimezones)
			.setSupportedLanguages(action.supportedLanguages)
			.setHeadersForSelectRepo(action.headers)
			.setTags(action.availableTags)
	),
	on(fetchDepotHeadersFail, (state) => state.setLoading(false)),
	on(openDepotHeaderFieldsSelection, triggerDetectAvailableHeaders, (state) =>
		state.setDepotSchema(null)
	),
	on(
		fetchDepotSchemaMappingSuccess,
		reconstructDepotSchemaMappingSuccess,
		(state, action) => state.setDepotSchema(action.mapping)
	),
	on(replaceCurrentLabelWith, (state, action) => {
		if (state.depotSchema !== null) {
			const updated = state.depotSchema.map((c) =>
				c.replaceWith(action.searchTerm, action.replaceWith)
			);
			return state.setDepotSchema(updated);
		}
		return state;
	}),
	on(updateEntitiesCountForDepotSuccess, (state, action) =>
		state.setDepotList(action.depotList)
	),
	on(deleteDepot, bulkDeleteDepots, (state) => state.setLoading(true)),
	on(deleteDepotFail, (state) => state.setLoading(false)),
	on(getDepotHeaderSettingSuccess, (state, action) =>
		state
			.setAvailableCharacteristicTypes(action.availableCharacteristicTypes)
			.setAvailableDateFormats(action.availableDateFormats)
			.setAvailableTimezones(action.availableTimezones)
			.setSupportedLanguages(action.supportedLanguages)
	)
);
